import { useState } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Box,
  Typography,
} from "@mui/material";

const steps = ["Booked", "Confirmed", "In Progress", "Completed"];

const BookingTracker = () => {
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    if (activeStep < steps.length - 1)
      setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    if (activeStep > 0) setActiveStep((prevStep) => prevStep - 1);
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          maxWidth: 600,
          margin: "auto",
          textAlign: "center",
          p: 3,
        }}
      >
        <Typography variant="h5" sx={{ mb: 3 }}>
          Booking Status
        </Typography>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box sx={{ mt: 4 }}>
          <Button
            disabled={activeStep === 0}
            onClick={handleBack}
            variant="outlined"
            sx={{ mr: 2 }}
          >
            Back
          </Button>
          <Button
            disabled={activeStep === steps.length - 1}
            onClick={handleNext}
            variant="contained"
          >
            Next
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default BookingTracker;
